export default {
  envStr: 'devLocal',
  appName: '方舟物联网平台',
  apiHost: '/dev-api',
  docUrl: 'http' + '://192.168.1.111:30080',
}
